<template>
  <div class="fixed inset-0 bg-gradient-to-br from-primary/5 via-background to-secondary/5 flex flex-col items-center justify-center">
    <!-- Icon 容器 -->
    <div class="relative mb-8">
      <!-- 旋轉光環 -->
      <div class="absolute inset-0 flex items-center justify-center">
        <div class="w-32 h-32 rounded-full border-4 border-primary/20 border-t-primary animate-spin"></div>
      </div>

      <!-- 脈衝外圈 -->
      <div class="absolute inset-0 flex items-center justify-center animate-pulse">
        <div class="w-36 h-36 rounded-full bg-primary/5"></div>
      </div>

      <!-- Icon -->
      <div class="relative z-10 w-24 h-24 flex items-center justify-center">
        <img
          src="/icon.png"
          alt="寶寶疫苗小幫手"
          class="w-full h-full object-contain drop-shadow-lg"
        />
      </div>
    </div>

    <!-- 文字 -->
    <div class="text-center space-y-2">
      <h2 class="text-xl font-bold text-textMain">寶寶疫苗小幫手</h2>
      <p class="text-sm text-textMuted animate-pulse">載入中...</p>
    </div>

    <!-- 進度條 -->
    <div class="mt-8 w-48">
      <div class="h-1 bg-gray-200 rounded-full overflow-hidden">
        <div class="h-full bg-gradient-to-r from-primary to-secondary animate-loading-bar"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// 純展示組件，無需邏輯
</script>

<style scoped>
@keyframes loading-bar {
  0% {
    width: 0%;
  }
  50% {
    width: 70%;
  }
  100% {
    width: 100%;
  }
}

.animate-loading-bar {
  animation: loading-bar 2s ease-in-out infinite;
}

/* 旋轉動畫 */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 2s linear infinite;
}

/* 脈衝動畫 */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
